import React from 'react'
import Image from '../../../images/sellerpolicies/13.png'

const Payment_policy = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>PAYMENT Policy</h2>
            <p>KAAY reserve the right on behalf of the seller to receive, process and disperse payments.</p>
            <p>After receiving the payment from the customer, KAAY shall disperse the payment of the amount upon sale of the product deducting its commission and any fees/penalty if applicable.</p>
            <p>After the order is fulfilled, KAAY will hold the seller’s payment for (7) working days on behalf of the customer. In Case a customer raises a claim on the product the payment will be held hold until the KAAY customer support department resolve the claim otherwise on the eighth day (8) the payment will be transferred to the seller-provided bank account.</p>
            <p>It will be the duty of KAAY to provide digital Invoices for every transaction between the seller and KAAY.</p>
            <p>Seller agrees that KAAY shall not be liable for any failure to make payments arising due to incomplete or inaccurate information provided by the Seller with regards to its Bank Account</p>
        </div>
      </div>
    </div>
  )
}

export default Payment_policy
